import React from "react";

const OnboardPassword = ({
  width = 88,
  height = 88,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 88 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="87"
        height="87"
        rx="43.5"
        fill="url(#paint0_linear_1050_35337)"
      />
      <rect
        x="0.5"
        y="0.5"
        width="87"
        height="87"
        rx="43.5"
        stroke="url(#paint1_linear_1050_35337)"
      />
      <g filter="url(#filter0_d_1050_35337)">
        <rect x="16" y="16" width="56" height="56" rx="28" fill="white" />
        <rect
          x="16.5"
          y="16.5"
          width="55"
          height="55"
          rx="27.5"
          stroke="#E2E4E9"
        />
        <path
          d="M51.3498 41.9H52.3998C52.6783 41.9 52.9454 42.0106 53.1423 42.2075C53.3392 42.4045 53.4498 42.6715 53.4498 42.95V53.45C53.4498 53.7285 53.3392 53.9955 53.1423 54.1925C52.9454 54.3894 52.6783 54.5 52.3998 54.5H35.5998C35.3213 54.5 35.0543 54.3894 34.8573 54.1925C34.6604 53.9955 34.5498 53.7285 34.5498 53.45V42.95C34.5498 42.6715 34.6604 42.4045 34.8573 42.2075C35.0543 42.0106 35.3213 41.9 35.5998 41.9H36.6498V40.85C36.6498 39.8848 36.8399 38.929 37.2093 38.0373C37.5787 37.1455 38.1201 36.3353 38.8026 35.6528C39.4851 34.9703 40.2953 34.4289 41.1871 34.0595C42.0788 33.6901 43.0346 33.5 43.9998 33.5C44.965 33.5 45.9208 33.6901 46.8125 34.0595C47.7043 34.4289 48.5145 34.9703 49.197 35.6528C49.8796 36.3353 50.4209 37.1455 50.7903 38.0373C51.1597 38.929 51.3498 39.8848 51.3498 40.85V41.9ZM49.2498 41.9V40.85C49.2498 39.4576 48.6967 38.1223 47.7121 37.1377C46.7276 36.1531 45.3922 35.6 43.9998 35.6C42.6074 35.6 41.2721 36.1531 40.2875 37.1377C39.3029 38.1223 38.7498 39.4576 38.7498 40.85V41.9H49.2498ZM42.9498 46.1V50.3H45.0498V46.1H42.9498Z"
          fill="#525866"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1050_35337"
          x="12"
          y="14"
          width="64"
          height="64"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.105882 0 0 0 0 0.109804 0 0 0 0 0.113725 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1050_35337"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1050_35337"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1050_35337"
          x1="44"
          y1="0"
          x2="44"
          y2="88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4E5E7" stopOpacity="0.48" />
          <stop offset="1" stopColor="#F7F8F8" stopOpacity="0" />
          <stop offset="1" stopColor="#E4E5E7" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1050_35337"
          x1="44"
          y1="0"
          x2="44"
          y2="88"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E4E5E7" />
          <stop offset="0.765625" stopColor="#E4E5E7" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default OnboardPassword;
